import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useOnboardingPack } from '../context/OnboardingPackProvider';
import { isOnboardingProfileComplete } from '../utils/onboardingProfileGate';
import { buildWizardFormFromUser } from '../utils/wizardFormFromUser';
import WorkoutWizardModal from './WorkoutWizardModal';
import WorkoutWizardNudge from './WorkoutWizardNudge';

const autoShownKey = (userId) => `iron_wizard_auto_shown_${userId}`;

function wasAutoShown(userId) {
  try {
    return sessionStorage.getItem(autoShownKey(userId)) === '1';
  } catch {
    return false;
  }
}

function markAutoShown(userId) {
  try {
    sessionStorage.setItem(autoShownKey(userId), '1');
  } catch {
    /* ignore */
  }
}

export default function WorkoutWizardHost() {
  const { user, isAuthenticated, loading: authLoading } = useAuth();
  const location = useLocation();
  const { openWizard, wizardOpen, suggestions } = useOnboardingPack();

  const isAuthPage =
    location.pathname === '/login' ||
    location.pathname === '/register' ||
    location.pathname === '/start' ||
    location.pathname.startsWith('/register/');

  useEffect(() => {
    if (authLoading || !isAuthenticated || !user?.id || isAuthPage) return;

    if (suggestions.length > 0) return;

    const formData = buildWizardFormFromUser(user);
    if (isOnboardingProfileComplete(formData)) return;

    if (!wasAutoShown(user.id)) {
      markAutoShown(user.id);
      openWizard({ mode: 'forced', contextLabel: 'onboarding', step: 'profile' });
    }
  }, [authLoading, isAuthenticated, user, isAuthPage, openWizard, suggestions.length]);

  if (!isAuthenticated || isAuthPage) return null;

  const formData = buildWizardFormFromUser(user);
  const profileComplete = isOnboardingProfileComplete(formData);
  const showNudge = !profileComplete && !wizardOpen && wasAutoShown(user?.id);

  return (
    <>
      {showNudge && (
        <WorkoutWizardNudge
          onContinue={() => openWizard({ mode: 'forced', contextLabel: 'onboarding', step: 'profile' })}
        />
      )}
      <WorkoutWizardModal />
    </>
  );
}
